import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';
import useCountries from '../hooks/useCountries';
import MissingInfo from '../pages/Review/MissingInfo';
import { findCountryByCode } from '../util/helpers/countries';
import Paragraph from './Paragraph/Paragraph';

export const CountryName = styled.span`
  color: inherit;
`;

const AddressReviewFormat = ({
  AptOrSuite,
  Apartment,
  Street,
  City,
  StateCaption,
  PostalCode,
  CountryIso3Code,
  isCustodian,
}) => {
  const countries = useCountries();
  const isEmptyState = isCustodian
    ? false
    : !Street || !City || !StateCaption || !PostalCode || !CountryIso3Code;
  let streetComponent = null;
  let cityComponent = null;
  let stateComponent = null;
  let postalComponent = null;

  if (AptOrSuite || Street) {
    streetComponent =
      AptOrSuite || Apartment
        ? ` ${Street} ${AptOrSuite || Apartment}, `
        : `${Street}, `;
  }
  if (City) {
    cityComponent = `${City}, `;
  }
  if (StateCaption) {
    stateComponent = `${StateCaption}, `;
  }
  if (PostalCode) {
    postalComponent = `${PostalCode}`;
  }
  if (isEmptyState) {
    return <MissingInfo />;
  }
  return (
    <>
      <Paragraph color={themeColors.colorTextXLLight} variant="normal">
        {streetComponent}
        {cityComponent}
        {stateComponent}
        {postalComponent}
        {CountryIso3Code && (
          <>
            {', '}
            <CountryName>
              {findCountryByCode(countries, CountryIso3Code)}
            </CountryName>
          </>
        )}
      </Paragraph>
    </>
  );
};

AddressReviewFormat.propTypes = {
  AptOrSuite: PropTypes.string,
  Apartment: PropTypes.string,
  Street: PropTypes.string,
  City: PropTypes.string,
  isCustodian: PropTypes.bool,
  StateCaption: PropTypes.string,
  PostalCode: PropTypes.string,
  CountryIso3Code: PropTypes.string,
};

export default AddressReviewFormat;
